<template>
  <div class="ge_main" @click="onDown">
    <img class="bg_img" src="/static/hd/ganen/hd_bg.jpg" alt="" >
    <div class="buttom_div">
      <img class="buttom_img" src="/static/hd/ganen/hd_buttom.png" alt="">
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import tools from '@/tools/tools'

export default {
  name: 'HuoDongGanenMobile',
  components: {
  },
  data: () => {
    return {
      item: {
        downKey: 'sdmj'
      }
    }
  },
  mounted () {
  },
  methods: {
    onDown () {
      tools.iosDoLocation(this.$store.getters.getDownNow(this.item.downKey))
    }
  },
  computed: {

  }
}
</script>
<style scoped>
.ge_main {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100000;
}
.bg_img {
  width: 100%;
}
.buttom_div {
  position: fixed;
  bottom: 0;
}
.buttom_img {
  width: 100%;
}
</style>
